import { Form, Input, Button, Alert } from 'antd';
import { UserOutlined, QuestionCircleFilled } from '@ant-design/icons';
import '../index.css';
import './style.css';
import { IResultSet } from '../../components/infrastructure/models';
import React from 'react';
import { Link } from 'react-router-dom';
import { Core } from '../../components/infrastructure/core';
import { Captcha } from '../../components/captcha/index';
import RegisterPolicyholder from './registerPolicyholder';
import PolicyholderLogin from './policyholderLogin';
import AppContext from '../../components/infrastructure/appContext';
import { RegisterSerialOrIMEI } from './registerSerialOrIMEI';

interface IPolicyholderLoginState {
    loading?: boolean;
    phone?: string;
    phoneNotDefined?: boolean;
    exists?: boolean;
    isNew?: boolean;
    userName?: string;
    captcha: string;
    lastSendCode?: number;
    inquerySerialOrIMEI?: boolean;
}

interface ICheckPolicyholder {
    NationalCode?: string;
    Exists?: boolean;
    Phone: string;
    LastSendCode?: number;
    IsNew?: boolean;
}

const PolicyholderCheckLogin = () => {
    const { params } = React.useContext(AppContext);
    const [state, setState] = React.useState<IPolicyholderLoginState>({ phone: params['phone'], userName: params['username'], captcha: '' });
    const [form] = Form.useForm();

    const componentWillUnmount = React.useRef(false);

    const check = async (values: any) => {
        const nationalCode = values['nationalCode'];
        if (!!nationalCode && nationalCode !== "" && !Core.isNationalCode(nationalCode)) {
            Core.errorNotification('کد ملی باید معتبر باشد');
            return;
        }

        setState({ ...state, loading: true });

        let response = await fetch("api/userpolicyholder/checknationalcode", {
            method: 'POST',
            body: JSON.stringify({
                captcha: values['captcha'],
                nationalCode
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current === true)
            return;

        let result: IResultSet<ICheckPolicyholder> = await response.json();
        if (!result.ValidationState.Successful) {
            Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
            setState({ ...state, loading: false });
        }
        else {
            if (result.ValidationState.ValidationResults.length) {
                Core.successNotification(result.ValidationState.ValidationResults[0].Message);
            }
            if (!!result.Data) {
                const { Phone, Exists, NationalCode, LastSendCode, IsNew } = result.Data!;
                if (Exists === false)
                    Core.successNotification('لطفا مشخصات خود را استعلام نموده و ثبت نمایید');
                if (IsNew === true)
                    Core.successNotification('لطفا سریال یا IMEI دستگاه موبایل را استعلام نمایید');
                setState({ ...state, phone: Phone, phoneNotDefined: !result.Data?.Phone || result.Data?.Phone === "", exists: Exists, userName: NationalCode, captcha: values['captcha'], lastSendCode: LastSendCode, isNew: IsNew });
                return;
            }
            setState({ ...state, loading: false });
        }
    };

    const onFinish = async (values: any) => {
        if (state.loading)
            return;

        await check(values);
    };

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    if (state.exists === false) {
        return <RegisterPolicyholder
            nationalCode={state.userName!}
            onReturn={() => setState({ captcha: '' })}
            onRegistered={(userName, phone, captcha, isNew) => setState({ userName, phone, exists: true, captcha, isNew })} />;
    }
    else if (state.userName && state.isNew && !state.inquerySerialOrIMEI) {
        return <RegisterSerialOrIMEI
            nationalCode={state.userName!}
            captcha={state.captcha}
            onRegistered={captcha => setState({ ...state, captcha, inquerySerialOrIMEI: true })}
            onReturn={() => setState({ captcha: '' })}
        />;
    }
    else if (state.userName) {
        return <PolicyholderLogin
            userName={state.userName}
            phone={state.phone}
            phoneNotDefined={state.phoneNotDefined}
            onReturn={() => setState({ captcha: '' })}
            captcha={state.captcha}
            lastSendCode={state.lastSendCode}
        />;
    }

    return (
        <>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/userlogo.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>ورود بیمه گزار/مشتری</p>
            </div>

            <Form
                form={form}
                //labelCol={{ span: 6 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onReset={() => {
                    setState({ loading: false, captcha: '' });
                }}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%", textAlign: "right" }}
            >
                {state.exists === undefined && !state.userName &&
                    <Alert
                        style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                        message={"بیمه گزار/مشتری گرامی، لطفا جهت ورود به پورتال، کد ملی خود را وارد نمایید."}
                        showIcon
                        type="info"
                    />
                }

                <Form.Item
                    name="nationalCode"
                    //label="کد ملی"
                    rules={[
                        { required: true, message: 'کد ملی الزامی است' },
                        {
                            validator: () => {
                                const nationalCode = form.getFieldValue('nationalCode');
                                if (!!nationalCode && !Core.isNationalCode(nationalCode))
                                    return Promise.reject(new Error('کد ملی میبایست معتبر باشد'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        autoComplete="off"
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="کد ملی"
                        disabled={!!state.phone && state.phone !== ""}
                        onKeyPress={(event: any) => {
                            if (event.charCode < 48 || event.charCode > 57) {
                                event.preventDefault();
                            }
                        }}
                        maxLength={10}
                    />
                </Form.Item>

                {!state.loading &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                <Form.Item
                    style={{ direction: 'ltr', textAlign: 'justify' }}
                >
                    {state.phoneNotDefined && <Link className="login-form-forgot" to={{ pathname: '/changecontact', search: "?username=" + state.userName }} >تغییر شماره موبایل</Link>}
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                        بررسی
                    </Button>
                    <Link to={"/help"}>
                        <Button type="default" htmlType="button" className="login-form-button" icon={<QuestionCircleFilled style={{ color: 'cornflowerblue', float: 'left', marginTop: 2, marginRight: 5, transform: "scaleX(-1)" }} />}>
                            راهنما
                        </Button>
                    </Link>
                </Form.Item>
            </Form>
        </>
    );
};

export default PolicyholderCheckLogin;